import { TIdToPageMap } from 'models/common.model'
import { lazy } from 'react'
import { PageIdStylioArch61 } from './pages'

export const ID_TO_PAGE_MAP_STYLIO_ARCH_61: TIdToPageMap = {
  [PageIdStylioArch61.SUBSCRIPTIONS_ARCH_61]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch_61/pages/ArchSubscriptionPage').then(
        (m) => ({
          default: m.ArchSubscriptionPage,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_61/pages/ArchSubscriptionPage'),
  },
  [PageIdStylioArch61.SUB_UPSELL_ARCH_61]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch_61/pages/sub-upsell/SubUpsell').then(
        (m) => ({
          default: m.SubUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_61/pages/sub-upsell/SubUpsell'),
  },
  [PageIdStylioArch61.FACE_STYLING_PDF_UPSELL_ARCH_61]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_61/pages/third-pdf-upsell/ThirdPdfUpsell'
      ).then((m) => ({
        default: m.ThirdPdfUpsell,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_61/pages/third-pdf-upsell/ThirdPdfUpsell'
      ),
  },
  [PageIdStylioArch61.PROPORTIONS_PDF_UPSELL_ARCH_61]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch_61/pages/ProportionsPdfUpsell').then(
        (m) => ({
          default: m.ProportionsPdfUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_61/pages/ProportionsPdfUpsell'),
  },
  [PageIdStylioArch61.DOWNLOAD_ARCH_61]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_61/pages/download-arch/DownloadDefault'
      ).then((m) => ({
        default: m.DownloadDefault,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_61/pages/download-arch/DownloadDefault'
      ),
  },
}
